/**
 * Currencies Service
 * Handles all currency-related API calls
 */

import network from '../../Network/NetworkManager';

const APPURL = require('../../Constants/URLConstants');

/**
 * Get all currencies
 * @returns {Promise<Array>} - Array of currencies
 */
export const getCurrencies = async () => {
  try {
    const response = await network.networkCall(
      APPURL.URLPaths.currencies,
      'GET',
      '',
      '',
      '',
    );

    // Return currencies array from response
    if (response.status && response.data?.currencies) {
      return response.data.currencies;
    }

    return response.currencies || [];
  } catch (error) {
    console.error('Error fetching currencies:', error);
    return [];
  }
};
